module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-medium-3fbb3c7b7139acc85e1d600cc014c5c5.png";